import { useEffect, useState } from 'preact/hooks';
import { get, post, put, del } from '../api.js';
import { Link, navigate } from '../router.js';
import { Field, useForm } from '../ui/Field.jsx';
import { isDate } from '../../lib/dates.js';

const EMPTY = { name: '', contact: '', tourId: '', date: '', people: '', note: '' };

// SC-007: new booking (/rezervacije/nova, ?tourId=&date= from a tour's screen) or edit (/rezervacije/:id).
export function BookingForm({ params, query }) {
  const editId = params.id ? Number(params.id) : null;
  const tourId = !editId && /^\d+$/.test(query?.get('tourId') ?? '') ? query.get('tourId') : '';
  const date = !editId && isDate(query?.get('date')) ? query.get('date') : '';
  const [tours, setTours] = useState(null);
  const [missing, setMissing] = useState(false);
  const [f, bind, setF] = useForm({ ...EMPTY, tourId, date });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [t, list] = await Promise.all([get('/tours'), editId ? get('/bookings') : null]);
        if (list) {
          const b = list.bookings.find((x) => x.id === editId);
          if (!b) setMissing(true);
          else setF({ name: b.name, contact: b.contact, tourId: String(b.departure.tour.id), date: b.departure.start_date, people: String(b.people), note: b.note });
        }
        setTours(t.tours);
      } catch (e) {
        setError(e.message);
      }
    })();
  }, [editId]);

  const save = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const r = editId ? await put(`/bookings/${editId}`, f) : await post('/bookings', f);
      navigate(`/ture/${r.booking.departureId}`);
      return;
    } catch (err) {
      setError(err.message);
    }
    setBusy(false);
  };

  const remove = async () => {
    if (!confirm('Obrisati rezervaciju?')) return;
    setError(null);
    try {
      await del(`/bookings/${editId}`);
      navigate('/rezervacije');
    } catch (err) {
      setError(err.message);
    }
  };

  const title = editId ? 'Izmeni rezervaciju' : 'Nova rezervacija';
  let body = null;
  if (missing) {
    body = <p class="empty">Te rezervacije više nema. <Link href="/rezervacije">Na rezervacije</Link></p>;
  } else if (tours && tours.length === 0) {
    body = <p class="empty">Prvo dodaj turu u ponudu: <Link href="/ture">Ture → Ponuda</Link>.</p>;
  } else if (tours) {
    body = (
      <form class="panel booking-form" onSubmit={save}>
        <Field label="Ime i prezime"><input {...bind('name')} autocomplete="off" required /></Field>
        <Field label="Telefon ili mejl"><input {...bind('contact')} type="text" autocomplete="off" data-g3-mask /></Field>
        <Field label="Tura">
          <select {...bind('tourId')} required>
            <option value="" disabled>Izaberi turu</option>
            {tours.map((t) => <option key={t.id} value={String(t.id)}>{t.name}</option>)}
          </select>
        </Field>
        <Field label="Datum"><input {...bind('date')} type="date" required /></Field>
        <Field label="Broj ljudi"><input {...bind('people')} type="number" min="1" inputmode="numeric" required /></Field>
        <Field label="Napomena"><textarea {...bind('note')} rows="3" /></Field>
        {error && <p class="alert" role="alert">{error}</p>}
        <div class="actions">
          <button class="btn" disabled={busy}>Sačuvaj rezervaciju</button>
          {editId && <button type="button" class="btn-quiet btn-danger" onClick={remove}>Obriši rezervaciju</button>}
        </div>
      </form>
    );
  }

  return (
    <>
      <div class="page-head"><h1>{title}</h1></div>
      {!tours && error && <p class="alert" role="alert">{error}</p>}
      {body}
    </>
  );
}
